module.exports = __webpack_public_path__ + "static/media/STPOutstanding.empty.0354e755.png";